/// <amd-module name="Build/Admin/Common/Components/PoolIssueIcon" />
import * as React from "react";

import { CheckIssue, CheckIssueType } from "Checks/Client/Contracts/PipelinesChecks";
import { Icon } from "VSSUI/Icon";

export interface IPoolIssueIconProps {
    issue: CheckIssue;
}

export class PoolIssueIcon extends React.PureComponent<IPoolIssueIconProps> {
    public render(): JSX.Element {
        return (
            <Icon
                className={this.props.issue.type === CheckIssueType.Error ? "resource-error-icon" : "resource-warning-icon"}
                iconName={this.props.issue.type === CheckIssueType.Error ? "ErrorBadge" : "Warning"}
                tooltipProps={{
                    text: this.props.issue.message
                }}
            />
        );
    }
}
